<div
    class="search-suggestions-dropdown"
    [id]="idPrefix + '-search-listbox'"
    role="listbox"
    *ngIf="isOpen && (suggestions.suggestions.length || suggestions.documents.length)"
>
    <ul class="suggestions-list" *ngIf="suggestions.suggestions.length">
        <li
            *ngFor="let suggestion of suggestions.suggestions; let i = index"
            [id]="idPrefix + '-suggestion-option-' + i"
            class="suggestion-item selenium-suggestion-{{
                slugify(suggestion.text)
            }} selenium-type-{{ suggestion.type }}"
            role="option"
            [attr.aria-selected]="i === activeIndex"
            [class.active]="i === activeIndex"
            [class.touched]="isTouched(suggestion)"
            [class.last-smart-suggestion]="isLastSuggestion(i)"
            (mousedown)="$event.preventDefault()"
            (touchstart)="onItemTouchStart(suggestion)"
            (click)="onSelect(suggestion.text)"
        >
            <span class="suggestion-text"
                ><span class="suggestion-rest">{{
                    getHighlightParts(capitalizeFirstLetter(suggestion.text)).before
                }}</span
                ><span class="suggestion-match">{{
                    getHighlightParts(capitalizeFirstLetter(suggestion.text)).match
                }}</span
                ><span class="suggestion-rest">{{
                    getHighlightParts(capitalizeFirstLetter(suggestion.text)).after
                }}</span></span
            >
        </li>
    </ul>

    <div
        class="suggestion-documents"
        [class.with-divider]="suggestions.suggestions.length"
        *ngIf="suggestions.documents.length"
    >
        <div class="category-group" *ngFor="let group of suggestions.documents">
            <div
                class="category-heading selenium-subject-{{ slugify(group.category) }}"
                *ngIf="hasCategoryLabel(group)"
            >
                {{ group.category }}
            </div>
            <ul class="document-list">
                <li
                    *ngFor="let document of group.documents"
                    [id]="idPrefix + '-document-option-' + getDocumentGlobalIndex(document)"
                    class="document-item selenium-type-{{
                        document.objectType
                    }} selenium-suggestion-{{ slugify(document.title) }}"
                    role="option"
                    [attr.aria-selected]="isDocumentActive(document)"
                    [class.active]="isDocumentActive(document)"
                    [class.touched]="isTouched(document)"
                    (mousedown)="$event.preventDefault()"
                    (touchstart)="onItemTouchStart(document)"
                    (click)="onSelectDocument(document)"
                >
                    <img
                        [src]="document.posterImage"
                        alt=""
                        class="document-thumb"
                        loading="lazy"
                    />
                    <span class="document-text"
                        ><span class="suggestion-match">{{
                            capitalizeFirstLetter(searchTerm)
                        }}</span
                        ><span class="suggestion-context"> in {{ document.title }}</span></span
                    >
                    <span class="suggestion-type">({{ document.objectType }})</span>
                </li>
            </ul>
        </div>

        <button
            type="button"
            [id]="idPrefix + '-view-all-option'"
            class="view-all-btn"
            role="option"
            [attr.aria-selected]="isViewAllActive()"
            [class.active]="isViewAllActive()"
            [class.touched]="isTouched('view-all')"
            *ngIf="hasMoreResults()"
            (mousedown)="$event.preventDefault()"
            (touchstart)="onItemTouchStart('view-all')"
            (click)="onViewAllResults()"
            (blur)="onViewAllBlur($event)"
        >
            See all results for "{{ searchTerm }}"
        </button>
    </div>
</div>
